import { Modal } from '@foam/buoy/src/components/Modal/Modal';

interface NewConfirmationModalProps {
  isOpen: boolean;
  onConfirm?: () => void;
  onCancel: () => void;
  title?: string;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;
  paragraph?: string;
}

export const NewConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Leave page?',
  primaryActionLabel = 'Yes, leave',
  secondaryActionLabel = 'Stay',
  paragraph = 'Your changes have not been saved. Are you sure you want to leave this page?',
}: NewConfirmationModalProps) => (
  <Modal.Instance open={isOpen} onOpenChange={(open) => !open && onCancel()}>
    <Modal.Root
      title={title}
      primaryAction={
        onConfirm
          ? {
              label: primaryActionLabel,
              onClick: onConfirm,
            }
          : undefined
      }
      secondaryAction={
        onConfirm
          ? {
              label: secondaryActionLabel,
              onClick: onCancel,
            }
          : undefined
      }
      className="z-[100]"
    >
      <p className="text-root-size-body-xl font-400">{paragraph}</p>
    </Modal.Root>
  </Modal.Instance>
);
